import BaseDialog from "@/components/BaseDialog";


export const selectAiMaterialMixin = {
    methods: {
        // 智能选素材
        handleIntelligent() {
            console.log('智能选素材')
            const onSubmit = (data, isAuto) => {
                data.map((v)=> {
                    this.handleAdd(v)
                });
                if (isAuto) {
                   this.handleAuto(
                        this.getAdGroupKey, 
                        this.ad_group_list[this.getAdGroupKey] ? 
                        this.ad_group_list[this.getAdGroupKey]['material_list'] :
                        []
                    )
                }
                vm.close()
            };
            const select_value = this.value;
            const appData = this.appList.find(item=>item.app_id == this.formData.app_id);
            const displayData = this.display_type_list.find(item=>item.value == this.formData.display_type);
            const emiMaterialType = this.emi_material_type_list.find(item=>item.value == this.formData.emi_material_type);
            const list = [ { ...appData, tip: '当前产品' }, { ...displayData, tip: '当前版位' }, { ...emiMaterialType, tip: '当前规格' } ];
            const conf = [{
                config_type: this.source_params[select_value].config_type,  //素材类型
                conf_resolution: this.source_params[select_value].conf_resolution,  //尺寸
                conf_resolution_ratio: this.source_params[select_value].conf_resolution_ratio, //比例
                conf_format: this.source_params[select_value].conf_format,  //格式
                conf_size: this.source_params[select_value].conf_size,
            }];
            console.log(this.tableData, select_value, 'this.tableData');
            const exclude_material_md5 = this.tableData.map(v=>v[select_value]?.material_md5).filter(v=>v);
            console.log(exclude_material_md5, 'exclude_material_md5');
            const params = {
                conf,
                plat_id: 7,
                app_id: this.formData.app_id,
                exclude_material_md5
            }
            console.log(list, 'list');
            let cur_video = this.source_params.findIndex(item=>item.config_type == 3)

            if(cur_video != -1) {
                let cur_video_list = this.source_params.filter(item=>item.config_type == 3)
                params['conf'][0]['conf_length'] = cur_video_list[0].conf_length
            }
            const { vm } = selectAiMaterialModal({
                props: {
                    isVideo: this.source_params[select_value].config_type == 3,
                    list,
                    params,
                    appName: appData.app_name,
                },
                cbs: {
                    onSubmit,
                }
            })
        },
    }
}

// 智能选素材
function selectAiMaterialModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./selectAiMaterialModal'),
    options: {
      width: '1000px',
      title: '智能选素材',
      'lock-scroll': false,
      top: '20px'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.add('f-hide');
      }
    }
  })
}